import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Page } from '@gestor-web/app/shared/components';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class GuiasComPacoteService {
  constructor(private _simuladorGoApi: SimuladorGoApi) {}

  fetchData(
    operadora: string,
    competenciaInicial: string,
    competenciaFinal: string,
    cdTabelaTuss: string | null,
    cdProcedItem: string | null,
    pageData: Page,
  ) {
    return this._simuladorGoApi
      .fetchGuiasComPacote({
        regans: operadora,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        cd_tabela_tuss: cdTabelaTuss ?? undefined,
        cd_proced_item: cdProcedItem ?? undefined,
        page: pageData.page,
        size: pageData.size,
      })
      .pipe(
        map(data => ({ items: data.items ?? [], total: data.total ?? 0 })),
        catchError(() => of({ items: [], total: 0 })),
      );
  }

  fetchProcedimentosDisponiveis(
    operadora: string,
    competenciaInicial: string,
    competenciaFinal: string,
    cdTabelaTuss: string | null,
  ) {
    return this._simuladorGoApi
      .fetchProcedimentosGuiaComPacote({
        regans: operadora,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        cd_tabela_tuss: cdTabelaTuss ?? undefined,
      })
      .pipe(map(data => data.items ?? []));
  }

  getUltimoProcessamento(regans: string) {
    return this._simuladorGoApi.fetchGuiasComPacoteUltimoProcessamento({ regans });
  }
}